import { err, ok, Result } from "neverthrow"
import { sqlQuery } from "./ldb"
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'

export const selectEntityNames = async (): Promise<Result<string[], FusionError>> => {
	let r = await sqlQuery<{
		name: string
	}>(
		`
			select name
			  from sqlite_master
			 where type = 'table'
			 order by name asc
		`,
	)
	if(r.isErr()) {
		return err(serializeFusionError('selectEntityNames', r.error))
	}
	return ok(r.value.map(row => row.name))
}

// warning: not injection safe
// call from other internal functions with explicit strings only
// do not call with user data
export const selectAllPrettyJson = async (table: string, columns: string[]): Promise<string> => {
	const columnList = columns.map(c => `'${c}',${c}`).join(',')
	let r = await sqlQuery<{json: string}>(
		`
			select json_pretty(json_group_array(json_object(${columnList})))
			    as json
			  from ${table}
		`,
	)
	return r.isErr() ? JSON.stringify(r.error) : r.value[0].json
}

// warning: not injection safe
// call from other internal functions with explicit strings only
// do not call with user data
export const selectAllText = async (table: string, columns: string[]): Promise<string> => {
	let r = await sqlQuery(
		`
			select ${columns.join(', ')}
			  from ${table}
		`,
	)
	if(r.isErr()) {
		return JSON.stringify(r.error, null, 4)
	}
	let h: string[] = []
	h.push('[' + columns.join(', ') + ']')
	for(let row of r.value) {
		let parts: string[] = []
		for(let c of columns) {
			// @ts-ignore
			parts.push(row[c])
		}
		h.push(parts.join(', '))
	}
	return h.join('\n')
}

// export const selectAllHtml = async (table: string, columns: string[]): Promise<string> => {
// 	let r = await sqlQuery(
// 		`
// 			select ${columns.join(', ')}
// 			  from ${table}
// 		`,
// 	)
// 	if(r.isErr()) {
// 		return '<pre>' + JSON.stringify(r.error, null, 4) + '</pre>'
// 	}
// 	let h: string[] = []
// 	h.push('<table>')
// 	h.push('<thead><tr>')
// 	for(let c of columns) {
// 		h.push('<th>' + c + '</th>')
// 	}
// 	h.push('</tr></thead>')
// 	for(let row of r.value) {
// 		h.push('<tr>')
// 		for(let c of columns) {
// 			// @ts-ignore
// 			h.push('<td>' + row[c] + '</td>')
// 		}
// 		h.push('</tr>')
// 	}
// 	h.push('</table>')
// 	return h.join('')
// }
